import React from 'react';
import { Table } from 'semantic-ui-react';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import TableHeader from '@/components/table/TableHeader';
import TasksTableColumns from './TasksTableColumns';

const TasksTableHeader = ({
  category,
  columns,
  children,
  items,
  loaderButton,
  readErrors,
  readStatus,
}) => (
  <Table.Header fullWidth>
    <TableHeader
      isLoading={readStatus === states.PENDING}
      error={firstErrorMessage(readErrors)}
      numberOfColumns={columns.length}
      loaderButton={loaderButton}
    >
      {children}
    </TableHeader>
    <TasksTableColumns category={category} columns={columns} items={items} />
  </Table.Header>
);

export default TasksTableHeader;
